import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import H1 from 'UIComponents/elements/headings/H1';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PaidUsersFeatureTable from './PaidUsersFeatureTable';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PaidUsersModal = ({
  productLevel,
  productLine,
  onCloseClick,
  hideFreeUsersDisclaimer
}) => {
  return /*#__PURE__*/_jsxs(UIModal, {
    width: 700,
    use: "conversational",
    children: [/*#__PURE__*/_jsx(UIDialogHeader, {
      children: /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onCloseClick
      })
    }), /*#__PURE__*/_jsxs(UIDialogBody, {
      className: "flex-column justify-center",
      children: [/*#__PURE__*/_jsx(H1, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.seatsPicker.howMany"
        })
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        className: "m-bottom-5",
        message: "pricingPage.seatsPicker.paidUsersModal.primaryDifferenceSubtext"
      }), /*#__PURE__*/_jsx(PaidUsersFeatureTable, {
        productLine: productLine,
        productLevel: productLevel,
        hideFreeUsersDisclaimer: hideFreeUsersDisclaimer
      })]
    })]
  });
};
export default PaidUsersModal;